import React, { useCallback, useEffect, useState, FC } from 'react';
import { useIntl } from 'react-intl';
import InputRequireLogin from '../InputRequireLogin';
import { useUserMe } from '../../../../../hooks/api/me';
import { useResendVerificationMail } from '../../../../../hooks/api/sendVerification';
import { LoadingIconWithReloadButton } from '../../../../../molecules/common/LoadingIconWithReloadButton';
import EmailVerification, {
  VerificationContext,
} from '../../../../../molecules/common/EmailVerification';

type Props = {
  moveToNext: () => void;
  onRestart: () => void;
  renew?: boolean;
  resourcePublicId: string;
};

const ReservationFlowAuthPage: FC<Props> = ({
  moveToNext,
  onRestart,
  renew,
  resourcePublicId,
}) => {
  const intl = useIntl();
  const [isJustCreateUser, setIsJustCreateUser] = useState(false);
  const { isUserLoading, meResponseData: loginUser } = useUserMe();
  const { isValidating, resendVerificationMail } = useResendVerificationMail();

  const onJustCreateUser = useCallback(() => {
    setIsJustCreateUser(true);
  }, []);

  const onRequestResendEmail = useCallback(async () => {
    const res = await resendVerificationMail();
    if (res.success) {
      const message = intl.formatMessage({
        id: 'reservationFlowAuthPage.successResendEmail',
      });
      alert(message);
    } else {
      const message = intl.formatMessage({
        id: 'reservationFlowAuthPage.failedResendEmail',
      });
      alert(message);
    }
  }, [resendVerificationMail, intl]);

  useEffect(() => {
    if (loginUser?.is_email_verified) {
      moveToNext();
    }
  }, [loginUser?.is_email_verified, moveToNext]);

  if (isUserLoading) {
    return <LoadingIconWithReloadButton />;
  }

  if (loginUser) {
    // `useEffect`で次へ遷移するまでの間はこれを表示しておく
    if (loginUser.is_email_verified) {
      return <LoadingIconWithReloadButton />;
    }

    return (
      <EmailVerification
        isJustCreateUser={isJustCreateUser}
        email={loginUser.email}
        isValidating={isValidating}
        handleSubmit={onRequestResendEmail}
        verificationContext={VerificationContext.RESERVATION}
      />
    );
  } else {
    return (
      <InputRequireLogin
        onRestart={onRestart}
        renew={renew}
        onJustCreateUser={onJustCreateUser}
        resourcePublicId={resourcePublicId}
      />
    );
  }
};

export default ReservationFlowAuthPage;
